module.exports = __webpack_public_path__ + "img/p2.67ee5ebe.jpg";